module.exports = __webpack_public_path__ + "logo1.png";